import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Auth.css';
import googleLogo from '../assets/google-logo.png';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (password !== confirmPassword) {
      alert("Passwords do not match. Please try again.");
      return;
    }

    try {
      await createUserWithEmailAndPassword(auth, email, password);
      navigate('/profile-setup'); // Redirect to Profile Setup after email sign-up
    } catch (error) {
      console.error('Error signing up:', error);
    }
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // After Google Sign-Up, check if the user already has an artistName
      const response = await axios.get(`https://sync-api-troz.onrender.com/api/users/firebase/${user.uid}`);

      // Check if the artistName exists, if not, navigate to profile setup
      if (response.data.artistName) {
        navigate('/home');
      } else {
        navigate('/profile-setup');
      }
    } catch (error) {
      console.error('Error with Google Sign-Up:', error);
    }
  };

  return (
    <div className="auth-container">
      <h2 className='auth-header'>Sign up to start streaming, uploading, and earning</h2>
      <form onSubmit={handleSignUp}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="auth-input"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="auth-input"
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="auth-input"
        />
        <button type="submit" className="auth-button">Sign Up</button>
      </form>
      <button onClick={handleGoogleSignIn} className="auth-button google-signin">
        <img src={googleLogo} alt='google-logo' />
        Sign up with Google
      </button>
      <p className="auth-link">
        Already have an account? <Link to="/login">Login</Link>
      </p>
      <div className='legal-container'>
        <div className='legal-sentence'>
          By signing up you agree to our <a className='legal-link' href='/privacy-policy'>Privacy Policy</a>, <a className='legal-link' href='/end-user-license-agreement'>End User License Agreement</a>, and <a className='legal-link' href='/terms-of-service'>Terms of Service</a>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
